export const downloadFile = (href?: string, filename?: string): void => {
  if (!href) return;
  const link = document.createElement('a');
  link.href = href;
  if (filename) {
    link.download = filename;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
